
export const changeLocale = (locale) => {
  localStorage.setItem('locale', locale);
};